import * as React from 'react'

import { Link } from '@factorialco/deprecated-design-system'

interface Props {
  href: string
  label: string
}

const InformationLink = ({ href, label }: Props) => {
  return (
    <Link.Href href={href} target="_blank">
      {label}
    </Link.Href>
  )
}

export default InformationLink
